import { changeData } from '@services/api-service';

export const updateUser = (payload: FormData) => {
  return changeData({ requestUrl: 'updateUser', payload });
};
